// Import everything from autoload folder
import './autoload/ada-compliance.js'; import './autoload/foundation.js'; // eslint-disable-line

// Import local dependencies
import './plugins/lazyload';
import './plugins/modernizr.min';
import 'slick-carousel';
import 'jquery-match-height';
import objectFitImages from 'object-fit-images';
import '@fancyapps/fancybox/dist/jquery.fancybox.min';
// import { jarallax, jarallaxElement } from 'jarallax';
// import ScrollOut from 'scroll-out';

/**
 * Import scripts from Custom Divi blocks
 */
// eslint-disable-next-line import/no-unresolved
//import '../blocks/divi/example-block/index.js';

/**
 * Import scripts from Custom Elementor widgets
 */
// eslint-disable-next-line import/no-unresolved
//import '../blocks/elementor/example-widget/index.js';

/**
 * Import scripts from Custom ACF Gutenberg blocks
 */
// eslint-disable-next-line import/no-unresolved
//import '../blocks/gutenberg/acf-example-block/index.js';

/**
 * Init foundation
 */
$(document).foundation();

/**
 * Fit slide video background to video holder
 */
function resizeVideo() {
  let $holder = $('.videoHolder');
  $holder.each(function () {
    let $that = $(this);
    let ratio = $that.data('ratio') ? $that.data('ratio') : '16:9';
    let width = parseFloat(ratio.split(':')[0]);
    let height = parseFloat(ratio.split(':')[1]);
    $that.find('.video').each(function () {
      if ($that.width() / width > $that.height() / height) {
        $(this).css({
          width: '100%',
          height: 'auto',
        });
      } else {
        $(this).css({
          width: ($that.height() * width) / height,
          height: '100%',
        });
      }
    });
  });
}

function calcHeaderHeight() {
  let $header = $('.header');
  let $headerHeight = $header.outerHeight();
  let $bodyContent = $('.flexible-content');
  let $bar = $('#wpadminbar');
  let $barHeight = $bar.outerHeight();
  $header.css('margin-top', parseInt($barHeight));
  $bodyContent.css('margin-top', parseInt($headerHeight));
}

function fancyBoxImage() {
  /**
   * Add fancybox to images
   */
  $('.gallery-item')
    .find('a[href$="jpg"], a[href$="png"], a[href$="gif"]')
    .attr('rel', 'gallery')
    .attr('data-fancybox', 'gallery');
  $(
    '.fancybox, a[rel*="album"], a[href$="jpg"], a[href$="png"], a[href$="gif"]'
  ).fancybox({
    minHeight: 0,
    helpers: {
      overlay: {
        locked: false,
      },
    },
    toolbar: false,
    btnTpl: {
      // Arrows
      arrowLeft:
        '<button data-fancybox-prev class="fancybox-button fancybox-button--arrow fancybox-button--arrow_left" title="{{PREV}}">' +
        '<i class="fa fa-angle-left"></i>' +
        '</button>',

      arrowRight:
        '<button data-fancybox-next class="fancybox-button fancybox-button--arrow fancybox-button--arrow_right" title="{{NEXT}}">' +
        '<i class="fas fa-angle-right"></i>' +
        '</button>',
    },
    // eslint-disable-next-line no-unused-vars
    beforeLoad: function (instance, current) {
      // if (current.length) {
      // }
      $('.fancybox-button--arrow_left').appendTo(
        '.fancybox-slide--current > div'
      );
      $('.fancybox-button--arrow_right').appendTo(
        '.fancybox-slide--current > div'
      );
    },
  });
}

/**
 * Scripts which runs after DOM load
 */
$(document).on('ready', function () {
  // fancyBoxImage();
  $('.video-area__container a.fancybox').fancybox({
    maxWidth: 900,
    maxHeight: 600,
    fitToView: false,
    width: '90%',
    height: '90%',
    autoSize: false,
    closeClick: false,
    openEffect: 'none',
    closeEffect: 'none',
    iframe: {
      scrolling: 'auto',
      preload: true,
    },
  });
  $('.posts__list-select, .js-category').on('click', '.init', function () {
    $(this).closest('ul').children('li:not(.init)').toggle();
    $(this).closest('ul').toggleClass('opened');
    $(this).closest('ul').children('li.hide').removeClass('hide');
  });

  $(document).on('click', function (e) {
    if ($(e.target).is('.posts__list-select, .init') === false) {
      $('.posts__list-select').find('li.posts__tax-link').addClass('hide');
      $('.posts__list-select').removeClass('opened');
    }
  });

  var allOptions = $('.posts__list-select, .js-category').children(
    'li:not(.init)'
  );
  $('.posts__list-select, .js-category').on(
    'click',
    'li:not(.init)',
    function () {
      allOptions.removeClass('selected');
      $(this).addClass('selected');
      $(this).closest('ul').toggleClass('opened');
      $('.posts__list-select, .js-category')
        .children('.init')
        .html($(this).html());
      allOptions.toggle();
    }
  );
  $('.sorting-posts__tax').click(function () {
    $('.posts__list-select').toggleClass('arrow');
  });

  function loadPosts(response, taxonomy = false) {
    let offset = taxonomy ? 0 : $('.portfolio--cart').length;
    let category = $('.sorting-posts__tax').find('.active').data('category');

    $.ajax({
      type: 'GET',
      dataType: 'json',
      data: {
        action: 'filtration_ajax',
        offset: offset,
        category: category,
      },
      // eslint-disable-next-line no-undef
      url: ajax_object.ajax_url,
      success: function (response) {
        if (!taxonomy) {
          $('#ajax-posts').append(response.html);
          fancyBoxImage();
        } else {
          $('#ajax-posts').html(response.html);
          $('.more-posts').show();
          console.log(taxonomy);
          fancyBoxImage();
        }
        if ($('.portfolio--cart').length >= response.post_count) {
          $('.more-posts').hide();
        }
      },
      error: function (result) {
        console.warn(result);
      },
    });
    return false;
  }

  $('.more-posts').on('click', function () {
    loadPosts('response');
  });
  $('.posts__tax-link').click(function (e) {
    e.preventDefault();
    $('.posts__tax-link').removeClass('active');
    $(this).addClass('active');
    loadPosts('response', true);
  });

  $('.js-testimonial-slider').slick({
    infinite: true,
    dots: true,
    arrows: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          arrows: false,
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  });

  /**
   * Make elements equal height
   */
  $('.matchHeight').matchHeight();

  $('#help, .help').on('click', function () {
    $('html').addClass('fixed');
    $('.popup-form').removeClass('d-none');
  });

  $('.close ').on('click', function () {
    $('html').removeClass('fixed');
    $('.popup-form').addClass('d-none');
  });

  $('.popup-form__container #gform_submit_button_1').submit(function (e) {
    e.preventDefault();
    // Coding
    $('#form').modal('hide');
    $('html').removeClass('fixed');
    return false;
  });

  /**
   * IE Object-fit cover polyfill
   */
  if ($('.of-cover').length) {
    objectFitImages('.of-cover');
  }

  /**
   * Init parallax
   */
  // jarallaxElement();
  // jarallax(document.querySelectorAll('.jarallax'), {
  //   speed: 0.5,
  // });

  /**
   * Detect element appearance in viewport
   */
  // ScrollOut({
  //   offset: function() {
  //     return window.innerHeight - 200;
  //   },
  //   once: true,
  //   onShown: function(element) {
  //     if ($(element).is('.ease-order')) {
  //       $(element)
  //         .find('.ease-order__item')
  //         .each(function(i) {
  //           let $this = $(this);
  //           $(this).attr('data-scroll', '');
  //           window.setTimeout(function() {
  //             $this.attr('data-scroll', 'in');
  //           }, 300 * i);
  //         });
  //     }
  //   },
  // });

  /**
   * Remove placeholder on click
   */
  const removeFieldPlaceholder = () => {
    $('input, textarea').each((i, el) => {
      $(el)
        .data('holder', $(el).attr('placeholder'))
        .on('focusin', () => {
          $(el).attr('placeholder', '');
        })
        .on('focusout', () => {
          $(el).attr('placeholder', $(el).data('holder'));
        });
    });
  };

  removeFieldPlaceholder();

  $(document).on('gform_post_render', () => {
    removeFieldPlaceholder();
  });

  /**
   * Scroll to Gravity Form confirmation message after form submit
   */
  $(document).on('gform_confirmation_loaded', function (event, formId) {
    let $target = $('#gform_confirmation_wrapper_' + formId);
    if ($target.length) {
      $('html, body').animate({ scrollTop: $target.offset().top - 550 }, 500);
      return false;
    }
  });

  $(document).on('gform_confirmation_loaded', function () {
    let $target = $('.popup-form #gform_confirmation_wrapper_1');
    if ($target.length) {
      $('html, body').stop();
      return false;
    }
  });

  /**
   * Hide gravity forms required field message on data input
   */
  $('body').on(
    'change keyup',
    '.gfield input, .gfield textarea, .gfield select',
    function () {
      let $field = $(this).closest('.gfield');
      if ($field.hasClass('gfield_error') && $(this).val().length) {
        $field.find('.validation_message').hide();
      } else if ($field.hasClass('gfield_error') && !$(this).val().length) {
        $field.find('.validation_message').show();
      }
    }
  );

  /**
   * Add `is-active` class to menu-icon button on Responsive menu toggle
   * And remove it on breakpoint change
   */
  $(window)
    .on('toggled.zf.responsiveToggle', function () {
      $('.menu-icon').toggleClass('is-active');
    })
    .on('changed.zf.mediaquery', function () {
      $('.menu-icon').removeClass('is-active');
    });

  /**
   * Close responsive menu on orientation change
   */
  $(window).on('orientationchange', function () {
    setTimeout(function () {
      if ($('.menu-icon').hasClass('is-active') && window.innerWidth < 641) {
        $('[data-responsive-toggle="main-menu"]').foundation('toggleMenu');
      }
    }, 200);
  });

  resizeVideo();
});

/**
 * Scripts which runs after all elements load
 */
$(window).on('load', function () {
  // jQuery code goes here
  fancyBoxImage();
  calcHeaderHeight();

  let $preloader = $('.preloader');
  if ($preloader.length) {
    $preloader.addClass('preloader--hidden');
  }
});

/**
 * Scripts which runs at window resize
 */
$(window).on('resize', function () {
  // jQuery code goes here

  resizeVideo();
});

/**
 * Scripts which runs on scrolling
 */
$(window).on('scroll', function () {
  // jQuery code goes here
});
